import cx from "@hsl/core/utils/cx";

type Props = {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
};

const CardColCell = ({ children, className, onClick }: Props) => {
    return (
        <span
            onClick={onClick}
            role={onClick ? "button" : undefined}
            className={cx(
                "hidden min-w-[150px] max-w-[150px] text-left text-sm md:inline-block",
                className,
            )}
        >
            {children}
        </span>
    );
};

export default CardColCell;
